import { JobSearchJobTypeResponse } from '@doda/api-client/aspida/@types';
import { LinkList } from '../../LinkList';
import { nonNullableText } from '../createLinkList';

/**
 * 職種の関連リンクPropsを生成する
 * @param jobSearchJobTypeResponse
 * @returns LinkList 職種の関連リンク
 */
export const createOccupationLinkList = (
  jobSearchJobTypeResponse?: JobSearchJobTypeResponse
): LinkList => ({
  separator: '＞',
  list: [
    {
      text: jobSearchJobTypeResponse?.searchJobTypeLName ?? '',
      href: jobSearchJobTypeResponse?.searchJobTypeLURL ?? '',
      count: jobSearchJobTypeResponse?.searchJobTypeLCount,
    },
    {
      text: jobSearchJobTypeResponse?.searchJobTypeMName ?? '',
      href: jobSearchJobTypeResponse?.searchJobTypeMURL ?? '',
      count: jobSearchJobTypeResponse?.searchJobTypeMCount,
    },
    {
      text: jobSearchJobTypeResponse?.searchJobTypeSName ?? '',
      href: jobSearchJobTypeResponse?.searchJobTypeSURL ?? '',
      count: jobSearchJobTypeResponse?.searchJobTypeSCount,
    },
  ].filter(nonNullableText),
});
